<template>
	<div>
		<div v-if="error">
			<v-alert type="error" :value="true">
				{{ error }}
			</v-alert>
		</div>
		<div v-else>
			<v-form ref="vantage_form">

				<v-layout v-if="form.parameters.hasOwnProperty('workflow_id')"
					row wrap class="pt-3">
					<v-autocomplete
						label="Workflow Vantage"
						:loading="loading_vantage_workflows"
						class="my-0 py-0"
						clearable
						dense
						autofocus
						persistent-hint
						:menu-props="{maxHeight: '80vh'}"
						:hint="selected_workflow_hint"
						@change="emitChange()"
						@click:clear="form.parameters.workflow_id = ''"
						:rules="[required]"
						item-value="id"
						item-text="name"
						:items="vantage_workflows"
						v-model="form.parameters.workflow_id">
						<template slot="selection" slot-scope="data">
							<v-list-tile-content class="pl-2">
								<v-list-tile-title>
									{{ data.item.name }}
								</v-list-tile-title>
							</v-list-tile-content>
						</template>
						<template slot="item" slot-scope="data">
							<template v-if="data.item.type === 'header'">
								<v-list-tile-content>
									<v-list-tile-title>
										{{ data.item.header }}
									</v-list-tile-title>
								</v-list-tile-content>
							</template>
							<template v-else>
								<v-list-tile-content>
									<v-list-tile-title>
										{{ data.item.name }}
									</v-list-tile-title>
									<v-list-tile-sub-title>
										{{ data.item.description || '-' }}
									</v-list-tile-sub-title>
								</v-list-tile-content>
								<v-list-tile-action>
									{{ data.item.mod_date | formatDateNoTime }}
								</v-list-tile-action>
							</template>
						</template>
					</v-autocomplete>
				</v-layout>

				<v-layout v-if="form.parameters.hasOwnProperty('label')"
					row wrap align-center>
					<v-text-field
						label="label"
						@change="emitChange()"
						v-model="form.parameters.label">
					</v-text-field>
				</v-layout>

				<v-layout v-if="form.parameters.hasOwnProperty('priority')"
					row wrap align-center>
					<v-flex shrink>
						<v-chip
							:color="priority_color"
							class="black--text font-weight-bold ml-0">
							Priorité {{ form.parameters.priority }}
						</v-chip>
					</v-flex>
					<v-flex grow>
						<v-slider
							min="0"
							max="10"
							@change="emitChange()"
							prepend-icon="remove"
							@click:prepend="form.parameters.priority--;emitChange()"
							append-icon="add"
							@click:append="form.parameters.priority++;emitChange()"
							:color="priority_color"
							v-model.number="form.parameters.priority">
						</v-slider>
					</v-flex>
				</v-layout>

				<span v-if="form.parameters.hasOwnProperty('asset_list')">
					<v-layout
						row wrap align-center class="mb-1 asset-card"
						v-for="(asset, i) in form.parameters.asset_list"
						:key="'asset_' + i">
						<v-flex shrink>
							<v-btn
								flat icon
								class="ma-0"
								color="warning"
								@click="removeAsset(i)">
								<v-icon>close</v-icon>
							</v-btn>
						</v-flex>
						<v-flex grow>
							{{ asset }}
						</v-flex>
					</v-layout>
				</span>

				<v-layout row wrap v-if="form.parameters.hasOwnProperty('asset_list')">
					<v-btn
						class="ml-0 text-none"
						color="primary color--text"
						@click="showExplorer = true">
						<v-icon class="mr-2">folder</v-icon>
						Explorer
					</v-btn>
					<v-btn
						class="ml-0 text-none"
						color="primary color--text"
						@click="showAssetFinder = true">
						<v-icon class="mr-2">search</v-icon>
						Asset finder
					</v-btn>
					<v-btn
						class="ml-0 text-none"
						color="primary color--text"
						@click="showTitleAssetFinder = true">
						<v-icon class="mr-2">manage_search</v-icon>
						Asset ID finder
					</v-btn>
					<v-btn
						class="ml-0 text-none"
						color="warning color--text"
						:disabled="!form.parameters.asset_list.length"
						@click="removeAsset(-1)">
						<v-icon class="mr-2">delete</v-icon>
						Vider la liste
					</v-btn>
				</v-layout>

				<v-layout row wrap v-if="form.parameters.hasOwnProperty('asset_list')">
					<v-checkbox
						color="primary"
						@change="emitChange()"
						:disabled="form.parameters.asset_list.length < 2"
						label="Générer un job par fichier"
						v-model="multiple_jobs">
					</v-checkbox>
				</v-layout>
			</v-form>

			<Explorer
				v-if="showExplorer"
				assetType="file"
				:multiselect="true"
				toolbarTitle="Selectionnez des assets"
				@close="showExplorer = false"
				@selectedAssets="addAssets($event)">
			</Explorer>

			<AssetFinder
				v-if="showAssetFinder"
				:multiselect="true"
				toolbarTitle="Selectionnez des assets"
				@close="showAssetFinder = false"
				@selectedAssets="addAssets($event)">
			</AssetFinder>

			<TitleAssetFinder
				v-if="showTitleAssetFinder"
				:multiselect="true"
				:return_file_paths="true"
				toolbarTitle="Selectionnez des assets"
				@close="showTitleAssetFinder = false"
				@selectedAssets="addAssets($event)">
			</TitleAssetFinder>
		</div>
	</div>
</template>

<script>
import Explorer from '@/components/modal_explorer.vue'
import AssetFinder from '@/components/modal_asset_finder.vue'
import TitleAssetFinder from '@/components/modal_title_asset_finder.vue'
export default {
	props: [ 'wf_data', 'debug', 'visible', 'details', 'param' ],
	components: {
		Explorer,
		AssetFinder,
		TitleAssetFinder
	},
	data () {
		return {
			error: false,
			vantage_workflows: [],
			loading_vantage_workflows: false,
			form: {
				isValid: false,
				parameters: {},
				jobdescriptorID: this.wf_data.descriptor_id,
				label: null,
				jobDescriptorVersion: this.wf_data.version_number
			},
			showExplorer: false,
			showAssetFinder: false,
			showTitleAssetFinder: false,
			multiple_jobs: false,
			required: v => (v !== '' && v !== null && v !== undefined) || 'Requis'
		}
	},
	watch: {
		wf_data () {
			this.setForm()
		},
		visible (val) {
			if (val) {
				if (this.param) {
					if (this.param.type.indexOf('file') > -1) {
						this.form.parameters['asset_list'] = []
						this.addAssets([{path: this.param.value}])
						return
					}
				}
				this.emitChange()
			}
		}
	},
	computed: {
		priority_color () {
			let colors = {
				0: 'valgrad0',
				1: 'valgrad1',
				2: 'valgrad2',
				3: 'valgrad3',
				4: 'valgrad4',
				5: 'valgrad5',
				6: 'valgrad6',
				7: 'valgrad7',
				8: 'valgrad8',
				9: 'valgrad9',
				10: 'valgrad10'
			}
			return colors[this.form.parameters.priority] || ''
		},
		selected_workflow_hint () {
			if (!this.form.parameters.workflow_id) return null
			let display = [this.form.parameters.workflow_id]
			for (let i = 0; i < this.vantage_workflows.length; i++) {
				const workflow = this.vantage_workflows[i]
				if (workflow.id === this.form.parameters.workflow_id) {
					if (workflow.description) display.push(workflow.description)
					break
				}
			}
			return display.join(' - ')
		}
	},
	methods: {
		setForm () {
			this.form.parameters = {}
			this.form.jobdescriptorID = this.wf_data.descriptor_id
			this.form.label = this.wf_data.label
			this.form.jobDescriptorVersion = this.wf_data.version_number || this.wf_data.version
			this.wf_data.parameters.map(desc => {
				let defaultValue = ''
				if (desc.type === 'multi-char') defaultValue = []
				if (desc.hasOwnProperty('default')) {
					if (desc.default !== '') defaultValue = desc.default
				}
				if (this.details) {
					if (this.details.hasOwnProperty(desc.name)) {
						defaultValue = this.details[desc.name]
					}
				}
				this.$set(this.form.parameters, desc.name, defaultValue)
			})
			if (this.param) {
				if (this.param.type) {
					if (this.param.type.indexOf('file') > -1) {
						this.addAssets([{path: this.param.value}])
					}
				}
			}
			this.emitChange()
		},
		getVantageWorkflows () {
			this.loading_vantage_workflows = true
			this.$ApiNexus.workflows()
				.then(result => {
					try {
						if (!result.data.length) {
							throw new Error('Impossible de lister les workflows Vantage')
						}
						let categories = {}
						result.data.map(wf => {
							if (!categories[wf.category]) {
								categories[wf.category] = []
							}
							categories[wf.category].push(wf)
						})
						for (const key in categories) {
							this.vantage_workflows.push({
								type: 'header',
								header: key
							})
							this.vantage_workflows.push(
								...categories[key]
							)
						}
						this.loading_vantage_workflows = false
					} catch (error) {
						this.error = error.message
						this.loading_vantage_workflows = false
					}
				})
				.catch(error => {
					this.error = error.message
					this.loading_vantage_workflows = false
				})
		},
		addAssets (assets) {
			assets.map(asset => {
				let assetIsNew = true
				this.form.parameters['asset_list'].map(selected_asset => {
					if (selected_asset === asset.path) {
						assetIsNew = false
					}
				})
				if (assetIsNew) {
					this.form.parameters['asset_list'].push(asset.path)
				}
			})
			this.$nextTick((arg) => {
				this.emitChange()
			})
		},
		removeAsset (index) {
			if (index === -1) {
				this.form.parameters.asset_list = []
				this.multiple_jobs = false
			} else {
				this.form.parameters.asset_list.splice(index, 1)
				if (this.form.parameters.asset_list.length < 2) {
					this.multiple_jobs = false
				}
			}
			this.$nextTick((arg) => {
				this.emitChange()
			})
		},
		validate () {
			let validity = this.$refs['vantage_form'].validate()
			return validity
		},
		emitChange () {
			this.form.isValid = this.validate()
			this.$nextTick((arg) => {
				let forms = []
				if (this.multiple_jobs) {
					this.form.parameters.asset_list.map(asset => {
						let form = JSON.parse(JSON.stringify(this.form))
						form.parameters.asset_list = asset
						forms.push(form)
					})
				} else {
					let form = JSON.parse(JSON.stringify(this.form))
					form.parameters.asset_list = form.parameters.asset_list.join(', ')
					forms.push(form)
				}
				this.$emit('change', forms)
			})
		}
	},
	mounted () {
		this.setForm()
		this.getVantageWorkflows()
	}
}
</script>

<style scoped lang="stylus">
.v-subheader
	background-color: var(--v-background-darken1)

.v-input--checkbox
	margin: 0
	.v-input__slot
		margin-bottom: 0 !important
		margin-top: .4em !important
		label
			margin-bottom: 0 !important

.v-input--checkbox.v-input--is-label-active
	.v-label
		color: var(--v-primary-base)

.v-select-list
	.v-list
		padding: 0

.asset-card
	background-color: rgba(10, 5, 20, 0.2)
</style>



// WEBPACK FOOTER //
// src/pages/maestro/jobs/launcher/job_launcher_form_generic_vantage_job.vue